import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-collabo-portal-updated-password',
  templateUrl: './collabo-portal-updated-password.component.html',
  styleUrls: ['./collabo-portal-updated-password.component.css'],
})
export class CollaboPortalUpdatedPasswordComponent implements OnInit {
  clientId: string;
  constructor() { }

  ngOnInit(): void {
  }
  // 登録サポートツール用か否か
  get isDxsales() {
    const app = environment.apps[this.clientId];
    return app.connection === 'CBPT-DxSales';
  }
}
